module.exports = __webpack_public_path__ + "img/1693448894034-2e0c157b-57fc-4139-a5ed-17e9ee2c67e5.jpeg.8b8883d0.webp";